import { flagForCurrency } from "@/components/ui/Flag"
import type { Market } from "@/lib/useMarket"

// The market's currency flag; nothing for a currency without one.
export default function MarketFlag({ market }: { market: Market }) {
  const Flag = flagForCurrency(market.currency)
  return Flag ? <Flag size={16} className="flex-shrink-0" /> : null
}
